import React from 'react';
import LinkIcon from '@mui/icons-material/Link';
import './AEHS.css'; // Import the CSS file
import { Container, Grid, Card, CardMedia, CardContent, Typography, Button } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import { translations } from './dataContent.js';
import aehspromo from '../../../../src/assets/images/aehspromo1.jpeg';
import aehspromo2 from '../../../../src/assets/images/aehspromo2.jpg';

const PromoPage = ({ language }) => {
  const t = translations[language] || translations.en;
  return (
    <div className="promoPageContainer">

      {/* Promos Section */}
      <div variant="h5" className="AEHSSubTitle d-flex justify-content-center">Promos</div>

      <div class="container promoPosters">
        <div class="row">
          {/* <div class="col-lg-4 col-md-3 col-sm-12 col-xs-12 mb-4">
            <img src={aehspromo} />
          </div> */}
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-4">
            <img src={aehspromo2} />
          </div>
        </div>
      </div>

      {/* Promo Banner */}
      <div className="promoBanner">
        <div className="promoContent">
          <Grid container spacing={4}>
            <Grid item xs={12} md={4} sx={{ display: { xs: 'none', sm: 'block' } }} className="promoImages">
              <img src="https://str4edfdevwebapp.blob.core.windows.net/images/regImgHuman.png" alt="Chef" className="chefImage" />
            </Grid>

            <Grid item xs={12} md={8}>
              <div className="">
                <div className='promotxt'>
                  <div className="AEHSSubTitle promoTitle">{t.Register_on_talent_of_deliciousness}</div>
                  <div className="promoDescription">
                    <br />
                    Join our culinary programs and discover the art of creating exquisite dishes.
                    With expert guidance and hands-on experience, you’ll sharpen your skills and elevate your talent,
                    preparing you for success in the dynamic world of gastronomy.
                  </div>
                  <div className="aehsbutton applybtn">
                    <div
                      onClick={() => window.open('https://forms.gle/s9rhYRDSZe1wuaN87', '_blank', 'noopener,noreferrer')}
                      style={{ cursor: 'pointer' }}
                    >
                      Apply Now
                    </div>
                  </div>
                  <div className="contactInfo">
                    <Typography><EmailIcon />&nbsp;Email: info@asianexotica.lk</Typography>
                    <Typography><PhoneIcon />&nbsp;Telephone:  077 730 5244/ 011 257 6881</Typography>
                  </div>
                </div>
              </div>
            </Grid>

            {/* <Grid item xs={12} md={3} sx={{ display: { xs: 'none', sm: 'block' } }} className="promoImages">
              <img src="https://str4edfdevwebapp.blob.core.windows.net/images/regImg2.png" alt="Food" className="foodImage" />
            </Grid> */}
          </Grid>
        </div>
      </div>

      {/* Important Links Section */}
      {/* <div className="AEHSSubTitle">Important Links</div>
      <Grid container spacing={2} className="importantLinks">
        <Grid item xs={12} sm={6} md={3}>
          <div className="linkButton"><LinkIcon />Application form<ChevronRightIcon /></div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="linkButton"><LinkIcon />Hand Book<ChevronRightIcon /></div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="linkButton"><LinkIcon />Guidance Book<ChevronRightIcon /></div>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <div className="linkButton"><LinkIcon />Assignment Cover page<ChevronRightIcon /></div>
        </Grid>
      </Grid> */}      
    </div>
  );
};

export default PromoPage;
